import React from "react";
import PropTypes from "prop-types";
import DurationProgress from "./DurationProgress";

class DurationProgressList extends React.Component {
  render() {
    const { trades, config } = this.props;

    const durations = trades.map((t, i) => {
      const bottom = i === 0 ? "0px" : i * (100 / config.maxOpenTrades) + "%";

      return (
        <DurationProgress
          key={i}
          config={config}
          trade={t}
          style={{
            height: 100 / config.maxOpenTrades + "%",
            opacity: "0.2",
            position: "absolute",
            bottom: bottom,
            left: "0px",
          }}
        />
      );
    });

    const thisStyle = {
      width: "100%",
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
    };

    const style = this.props.style ? { ...this.props.style, ...thisStyle } : thisStyle;

    return <div style={style}>{durations}</div>;
  }
}

DurationProgressList.propTypes = {
  style: PropTypes.object,
  config: PropTypes.object.isRequired,
  trades: PropTypes.array.isRequired,
};

export default DurationProgressList;



// WEBPACK FOOTER //
// ./src/components/DurationProgressList.js